import React from 'react';
import { Outlet } from 'react-router-dom';

export const StandardLayout: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8 md:px-6 max-w-[1400px] w-full">
      <Outlet />
    </div>
  );
};
